import { Fragment } from "react";
import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { useDispatch, useSelector } from "react-redux";

import { sessionDataHandler } from "../sessionDataHandler";
import { changeEngagementPhase, updatePreEngagementData } from "../store/actions/genericActions";
import { EngagementPhase, AppState } from "../store/definitions";
import { containerStyles, textStyles, titleStyles, buttonOkStyles } from "./styles/ConversationEnded.styles";
import type { Transcript } from "./Transcript";

export const ConversationEnded = () => {
    const dispatch = useDispatch();
    const { messages, users, preEngagementData, transcriptConfig } = useSelector((state: AppState) => ({
        messages: state.chat.messages,
        users: state.chat.users,
        preEngagementData: state.chat.conversation?.attributes.pre_engagement_data,
        transcriptConfig: state.config.transcript
    }));

    const handleStartNewChat = () => {
        sessionDataHandler.clear();
        dispatch(updatePreEngagementData({ email: "", name: "", query: "" }));
        dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
    };

    let TranscriptComponent: typeof Transcript | undefined = undefined;

    // This file and its related dependencies are only bundled if transcripts are enabled in .env file
    if (process.env.DOWNLOAD_TRANSCRIPT_ENABLED === "true" || process.env.EMAIL_TRANSCRIPT_ENABLED === "true") {
        // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-var-requires,global-require
        ({ Transcript: TranscriptComponent } = require("./Transcript"));
    }

    return (
        <Box {...containerStyles}>
            <Text as="span" {...titleStyles}>
                Merci pour votre échange !
            </Text>
            {TranscriptComponent ? (
                <TranscriptComponent
                    messages={messages}
                    preEngagementData={preEngagementData}
                    users={users}
                    transcriptConfig={transcriptConfig}
                />
            ) : (
                <Fragment />
            )}
            <Text as="p" {...textStyles}>
                Notre équipe est là pour vous aider à tout moment. Si vous avez d’autres questions, n’hésitez pas à
                revenir vers nous.
            </Text>

            <Box as="button" data-test="start-new-chat-button" onClick={handleStartNewChat} {...buttonOkStyles}>
                Commencer une nouvelle conversation
            </Box>
        </Box>
    );
};
